exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-size: 14px;\n  box-sizing: border-box;\n  background: #f4f6f9;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 100%;\n}\n\n#root{\n  height: 100%;\n}\n\ndiv {\n  overflow: initial;\n  box-sizing: border-box;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nul {\n  list-style: none;\n  margin: 0;\n}\n\nli {\n  list-style: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  background: #fff;\n}\n", ""]);

// exports
